/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmissionStatus } from './PalAuthSubmissionStatus';
import {
    PalAuthSubmissionStatusFromJSON,
    PalAuthSubmissionStatusFromJSONTyped,
    PalAuthSubmissionStatusToJSON,
} from './PalAuthSubmissionStatus';

/**
 * 
 * @export
 * @interface PalAuthSubmissionStatusInfo
 */
export interface PalAuthSubmissionStatusInfo {
    /**
     * 
     * @type {PalAuthSubmissionStatus}
     * @memberof PalAuthSubmissionStatusInfo
     */
    status: PalAuthSubmissionStatus;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionStatusInfo
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionStatusInfo
     */
    level?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionStatusInfo interface.
 */
export function instanceOfPalAuthSubmissionStatusInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function PalAuthSubmissionStatusInfoFromJSON(json: any): PalAuthSubmissionStatusInfo {
    return PalAuthSubmissionStatusInfoFromJSONTyped(json, false);
}

export function PalAuthSubmissionStatusInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionStatusInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': PalAuthSubmissionStatusFromJSON(json['status']),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'level': !exists(json, 'level') ? undefined : json['level'],
    };
}

export function PalAuthSubmissionStatusInfoToJSON(value?: PalAuthSubmissionStatusInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': PalAuthSubmissionStatusToJSON(value.status),
        'comment': value.comment,
        'level': value.level,
    };
}

